import React, { Component } from 'react';
import config from 'cfg';
import auth from '../../auth';
import * as rmd from 'material-ui';
import _ from 'lodash';
import IconUpload from 'material-ui/svg-icons/file/file-upload';

class DialogImport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            errorField: false,
            errorFile: false,
            uploadTemplateProcess: false,
            file: null,
            fileName: '',
            openImportDialog: this.props.show || false,
        };
    }

    componentWillReceiveProps({show}) {
        if (show) this.setState({ openImportDialog: show });
    }

    handleImport = ev => {
        const file = ev.target.files[0];

        this.setState({
            file: file,
            fileName: file ? file.name : '',
            errorFile: !file
        });
    };

    handleClose = () => {
        const {closeCb} = this.props;

        this.setState({
            name: '',
            uploadTemplateProcess: false,
            file: null,
            fileName: '',
            openImportDialog: false,
            errorField: false,
            errorFile: false
        });

        if (closeCb) closeCb();
    }

    handleSubmit = () => {
        const {file, name} = this.state;
        const {submitCb, closeCb, fileType, urlSubmit} = this.props;

        if (file && name) {
            return fetch(`${urlSubmit}?uploadName=${name}`, {
                method: 'POST',
                body: file,
                headers: {
                    'Content-Type': fileType || 'application/json',
                    authorization: auth.getAccessToken()
                }
            })
            .then(response => response.json())
            .then(res => {
                if (submitCb) submitCb(res);
                if (closeCb) closeCb();

                this.handleClose();
            })
            .catch(err => {
                console.error(err);
            });
        } else {
            this.setState({
                errorField: !name ? true : this.state.errorField,
                errorFile: !file ? true : this.state.errorFile,
            });
        }
    };

    render() {
        const {openImportDialog, errorField, errorFile} = this.state;
        const {dialogTitle, completeActionButtonText, fileType, textField} = this.props;

        return (
            <rmd.Dialog title={dialogTitle || 'Import'}
                modal={false}
                open={openImportDialog}
                onRequestClose={this.handleClose}
                actions={_.compact([
                    <rmd.FlatButton
                        label='Close'
                        onClick={this.handleClose}
                    />,
                    <rmd.FlatButton
                        primary
                        label={completeActionButtonText || 'Import'}
                        onClick={this.handleSubmit}
                    />
                ])}
            >
                <rmd.TextField fullWidth
                    floatingLabelText={textField || 'Template name'}
                    errorText={errorField ? 'This field is required' : ''}
                    name={this.state.name}
                    onChange={(e, name) => {
                        if (errorField && name.length) this.setState({ errorField: false });

                        this.setState({ name });
                    }}
                />
                <p style={{ margin: '17px 0 20px', color: ( errorFile ? 'rgb(244, 67, 54)' : 'inherit') }}>
                    {this.state.fileName ? (
                        <span>
                            <strong>File name: </strong> {this.state.fileName}
                        </span>
                    ) : (
                        <strong>{'Please load file'}</strong>
                    )}
                </p>
                <input hidden
                    accept={fileType || 'application/json'}
                    type='file'
                    id='import-file'
                    onChange={this.handleImport}
                />
                <rmd.RaisedButton
                    label='Select file'
                    style={{ position: 'relative' }}
                    primary
                    icon={this.state.uploadTemplateProcess ? (<rmd.CircularProgress size={24} />) : (<IconUpload />)}
                >
                    <label htmlFor='import-file'
                        style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            opacity: 0,
                            zIndex: 9,
                            cursor: 'pointer'
                        }}
                    >
                        Select file
                    </label>
                </rmd.RaisedButton>
            </rmd.Dialog>
        );
    }
}

export default DialogImport;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/DialogImport.js
 **/